import { Action, INIT, MetaReducer, UPDATE } from '@ngrx/store';

export function authMetaReducer(reducer: any): any {
    return (state: any, action: Action) => {

        if (action.type === INIT) {

            var token = null;
            var user = null;

            const storageToken = localStorage.getItem("token");
            const storageUser = localStorage.getItem("user");

            if(storageToken)
            {
                token = JSON.parse(storageToken);
            }

            if(storageUser)
            {
                user = JSON.parse(storageUser);
            }

            if(!state)
            {
                state = {
                    auth: {
                        user,
                        token
                    }
                }
            }
        }

        const nextState = reducer(state, action);
        return nextState;
    };
}

export const metaReducers: MetaReducer<any>[] = [authMetaReducer];